import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade show",
  id: "kt_modal_edit_meeting",
  "aria-modal": "true",
  role: "dialog",
  ref: "newTargetModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  id: "kt_modal_edit_meeting_close",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "fv-row mb-9 fv-plugins-icon-container" }
const _hoisted_10 = { class: "fs-6 fw-bold required mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_12 = { class: "fv-row mb-9" }
const _hoisted_13 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_14 = { class: "fv-row mb-9" }
const _hoisted_15 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_16 = { class: "row mb-5" }
const _hoisted_17 = { class: "col-md-12 fv-row" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = { class: "col-lg-8" }
const _hoisted_20 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_21 = { class: "row mb-5" }
const _hoisted_22 = { class: "col-md-8 fv-row" }
const _hoisted_23 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_24 = { class: "col-lg-8" }
const _hoisted_25 = {
  key: 1,
  class: "badge-light badge fs-8 fw-bolderms-1"
}
const _hoisted_26 = { class: "row row-cols-lg-2 g-10" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "fv-row mb-9 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_29 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_30 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "fv-row mb-9" }
const _hoisted_34 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_35 = { class: "modal-footer flex-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-dismiss": "modal",
  type: "reset",
  id: "kt_modal_edit_meeting_cancel",
  class: "btn btn-light me-3"
}, " Cancel ", -1)
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_39 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_40 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_edit_meeting_form",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
            () => {
              if (!(_ctx.targetData.date == '' || _ctx.targetData.date == null)) _ctx.submit();
            }
          , ["prevent"])),
          model: _ctx.targetData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("meeting.editMeeting")), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("meeting.topic")), 1),
                _createVNode(_component_el_form_item, { prop: "topic" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.topic,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.topic) = $event)),
                      placeholder: _ctx.t('meeting.topic'),
                      type: "text",
                      name: "topic"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("course.description")), 1),
                _createVNode(_component_el_form_item, { prop: "desc" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.desc,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.desc) = $event)),
                      type: "text",
                      placeholder: _ctx.t('course.description'),
                      name: "desc"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("timetable.cabinet")), 1),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.targetData.salle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.salle) = $event)),
                  type: "text",
                  placeholder: _ctx.t('timetable.cabinet'),
                  name: "salle"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("course.levels")), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetData.levels, (level) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "badge-light badge fs-8 fw-bolderms-1",
                          key: level
                        }, _toDisplayString(_ctx.t("dashboard.year" + level)), 1))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("course.teachers")), 1),
                  _createElementVNode("div", _hoisted_24, [
                    (
                      _ctx.targetData.teachers && _ctx.targetData.teachers.length != 0
                    )
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.targetData.teachers, (teacher) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "badge-light badge fs-8 fw-bolderms-1 ms-1",
                            key: teacher._id
                          }, _toDisplayString(teacher.employee.firstName +
                        " " +
                        teacher.employee.lastName), 1))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.t("course.allTeachers")), 1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("punishments.chooseDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.targetData.date,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.date) = $event)),
                          type: "datetime",
                          placeholder: _ctx.t('punishments.chooseDate'),
                          name: "date",
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDateRequired = true)),
                          format: "DD/MM/YYYY HH:mm:ss"
                        }, null, 8, ["modelValue", "placeholder"]),
                        (
                        (_ctx.targetData.date == '' || _ctx.targetData.date == null) &&
                        _ctx.showDateRequired
                      )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.t("course.requiredDate")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_31
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("meeting.duration")), 1),
                    _createVNode(_component_el_form_item, { prop: "duration" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.targetData.duration,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.targetData.duration) = $event)),
                          type: "text",
                          placeholder: _ctx.t('meeting.duration'),
                          name: "duration"
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDateRequired = true))
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_ctx.t("course.edit")) + " ", 1),
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                      _createTextVNode(_toDisplayString(_ctx.t("pleaseWait")) + " ", 1),
                      _hoisted_41
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_37)
            ]),
            _hoisted_42
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}